module.exports = __webpack_public_path__ + "img/Crinverlogoproy.09132fba.png";